// extracted by mini-css-extract-plugin
module.exports = {"root":"PageShell_root__GvuG1"};